var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMesage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mesage",
    transform: "translate(0 -1041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5883",
    "data-name": "Rectangle 5883",
    width: 64,
    height: 64,
    rx: 12,
    transform: "translate(0 1041)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(8.666 1075.121) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M33.712,13.689,8.178.173A1.479,1.479,0,0,0,6.008,1.48V7.51H1.479a1.478,1.478,0,1,0,0,2.957H6.008V22.528H1.479a1.478,1.478,0,1,0,0,2.957H6.008v3.027A1.479,1.479,0,0,0,7.487,29.99c.536,0-1.307.886,26.226-13.687A1.479,1.479,0,0,0,33.712,13.689ZM8.965,26.056V16.474H21a1.478,1.478,0,1,0,0-2.957H8.965V3.935L29.861,15Z",
    transform: "translate(1.502)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M1.479,2.957H3.732A1.478,1.478,0,1,0,3.732,0H1.479a1.478,1.478,0,1,0,0,2.957Z",
    transform: "translate(0 2.254)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M5.21,1.478A1.478,1.478,0,0,0,3.732,0H1.479a1.478,1.478,0,1,0,0,2.957H3.732A1.478,1.478,0,0,0,5.21,1.478Z",
    transform: "translate(0 17.272)",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesage);
export default __webpack_public_path__ + "static/media/mesage.346c4149b1af3d3bda073127a7ded513.svg";
export { ForwardRef as ReactComponent };